'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalArticles = function ExternalArticles(_ref) {
    var title = _ref.title;
    var articles = _ref.articles;
    var theme = _ref.theme;

    var id = 0;
    var list = articles.map(function (article) {
        return _react2.default.createElement(
            'li',
            { key: id++ },
            _react2.default.createElement(
                'a',
                { href: article.externalUrl },
                _react2.default.createElement(
                    'span',
                    null,
                    article.articleTitle
                ),
                _react2.default.createElement(
                    'div',
                    { className: theme.source, 'aria-label': 'Kilde:' },
                    article.externalDomain
                )
            )
        );
    });

    return _react2.default.createElement(
        'section',
        { className: theme['external-articles'] },
        _react2.default.createElement(
            'h2',
            null,
            title
        ),
        _react2.default.createElement(
            'ol',
            { 'aria-label': 'Liste over artikler fra andre aviser' },
            list
        )
    );
};

ExternalArticles.propTypes = {
    title: _propTypes2.default.string,
    articles: _propTypes2.default.array.isRequired, // eslint-disable-line react/forbid-prop-types
    theme: _propTypes2.default.shape({
        'external-articles': _propTypes2.default.string
    }).isRequired
};

ExternalArticles.defaultProps = {
    title: 'relaterte saker fra andre aviser',
    articles: {},
    theme: {}
};

exports.default = ExternalArticles;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/external-articles/lib/cjs/ExternalArticles/index.js
 ** module id = 721
 ** module chunks = 1
 **/